import { render, staticRenderFns } from "./profile-notification-setting.vue?vue&type=template&id=0374fb99&scoped=true&"
import script from "./profile-notification-setting.vue?vue&type=script&lang=js&"
export * from "./profile-notification-setting.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=0374fb99&scoped=true&lang=scss&"
import style1 from "./profile-notification-setting.vue?vue&type=style&index=1&id=0374fb99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0374fb99",
  null
  
)

component.options.__file = "profile-notification-setting.vue"
export default component.exports